import {
  STT_RECORDER_STATE_IDLE,
  STT_RECORDER_STATE_PAUSED,
  STT_RECORDER_STATE_RECORDING,
  STT_RECORDER_STATE_TRANSCRIBING
} from "../SpeechToText/useSpeechToTextRecorder";

export const ANSWER_MODE_VOICE = "voice";
export const ANSWER_MODE_WRITTEN = "written";
export const MESSAGE_ROLE_USER = "user";
export const INTERVIEW_STATUS_COMPLETED = "completed";
export const INTERVIEW_STATUS_IN_PROGRESS = "in_progress";
export const INTERVIEW_STATUS_PAUSED = "paused";

// Recorder events drive transient UI only; persisted interview status is updated by
// session mutations. This keeps the browser recording lifecycle out of domain state.
export const INTERVIEW_UI_STATE_IDLE = "idle";
export const INTERVIEW_UI_STATE_ASSISTANT_SPEAKING = "assistant_speaking";
export const INTERVIEW_UI_STATE_MIC_CHECK = "mic_check";
export const INTERVIEW_UI_STATE_READY_TO_SPEAK = "ready_to_speak";
export const INTERVIEW_UI_STATE_RECORDING = "recording";
export const INTERVIEW_UI_STATE_REVIEW = "review";
export const INTERVIEW_UI_STATE_THINKING = "thinking";
export const INTERVIEW_UI_STATE_TRANSCRIBING = "transcribing";

export const resolveRecorderUiStateTransition = ({
  currentUiState,
  recorderState,
  transcription
}) => {
  // An active take (recording or paused) must be represented so global interview
  // actions can be disabled instead of silently discarding the participant's audio.
  if (
    recorderState === STT_RECORDER_STATE_RECORDING ||
    recorderState === STT_RECORDER_STATE_PAUSED
  ) {
    return INTERVIEW_UI_STATE_RECORDING;
  }

  if (recorderState === STT_RECORDER_STATE_TRANSCRIBING) {
    return INTERVIEW_UI_STATE_TRANSCRIBING;
  }

  if (recorderState !== STT_RECORDER_STATE_IDLE) {
    return null;
  }

  const hasTranscription = transcription.trim().length > 0;
  const wasRecorderActive =
    currentUiState === INTERVIEW_UI_STATE_RECORDING ||
    currentUiState === INTERVIEW_UI_STATE_TRANSCRIBING;

  // If the take is canceled or STT ends with no usable transcription, return the user
  // to the ready-to-speak state.
  if (wasRecorderActive && !hasTranscription) {
    return INTERVIEW_UI_STATE_READY_TO_SPEAK;
  }

  return null;
};
